import { defaultPlaceholder } from "./defaultPlaceholder";
import { submotivosForSucursalDepartamento } from "./submotivosForSucursalDepartamento";

export const retriveSubmotivoData = (motivos, formik) => {
  const submotivosOptions = formik.values.motivo
    ? submotivosForSucursalDepartamento(
        motivos.filter((motivo) => motivo.itemId === formik.values.motivo),
        formik
      )
        .map((submotivo) => {
          return { label: submotivo.title, value: submotivo.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  let value = submotivosOptions.find((option) => {
    return option.value === formik.values.submotivo;
  });
  value = value || null;

  if ((value && value.value) !== formik.values.submotivo) {
    formik.setFieldValue("submotivo", value && value.value);
  }

  const placeholder = formik.values.motivo ? "Seleccione aqui el sub motivo" : defaultPlaceholder(formik);
  return [submotivosOptions, placeholder, value];
};
